import { useState, useEffect, useCallback } from "react";
import { useLocation, Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { getCasinoGameDetails, getMatchExposure } from "@/services/casinoApi";
import BetTableCmatch20 from "../components/cmatch20/BetTableCmatch20";
import ResultCt20 from "../components/cmatch20/ResultCt20";
import RightSection from "../components/RightSection/RightSection";
import styles from "./Cmatch20.module.css";
import VideoBox from "../components/common/VideoBox";
import CasinoHeading from "../components/common/CasinoHeading";

function extractCasinoGame(url) {
  const match = url.match(/\/lord-games\/([^/?#]+)/);
  return match ? match[1] : null;
}

// Helper function to normalize string for matching
const normalizeString = (str) => {
  if (!str) return "";
  return str.replace(/\s+/g, ' ').trim().toLowerCase();
};

// Helper function to create all exposure key variations
const createExposureKeys = (selection) => {
  if (!selection) return [];
  const keys = [
    selection,
    selection.toLowerCase(),
    selection.toLowerCase().trim(),
    selection.trim(),
    normalizeString(selection),
  ];
  return [...new Set(keys.filter(k => k))];
};

export default function Cmatch20() {
  const [gameData, setGameData] = useState({});

  console.log(gameData);
  const [activeTab, setActiveTab] = useState("game");
  const [iframeSrc, setIframeSrc] = useState("");
  const { pathname } = useLocation();
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);

  useEffect(() => {
    const name = extractCasinoGame(pathname) || "cmatch20";
    setIframeSrc(`https://casino-stream.softgamingapi.com/casino-tv?id=${name}`);

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(name);
        setGameData(response);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    // Start API calls after 5 seconds delay
    let intervalId = null;
    const initialTimeout = setTimeout(() => {
      fetchGameData();
      intervalId = setInterval(fetchGameData, 1500);
    }, 5000);

    return () => {
      clearTimeout(initialTimeout);
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [pathname]);

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id;
      const matchId = gameData?.data?.data?.mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            // For cmatch20, the selection might be "Run 2", "Run 3", etc.
            const selection = item.team_name || item.selection || item.player_name || item.nat || item.bet_type || item.name || "";
            const exposureAmount = parseFloat(item.exposure_amount || item.exposure || item.amount || item.exposure_amount_back || item.exposure_amount_lay || 0) || 0;

            // Get back and lay exposure separately if available
            const backExposure = parseFloat(item.exposure_amount_back || item.back_exposure || item.back || 0) || 0;
            const layExposure = parseFloat(item.exposure_amount_lay || item.lay_exposure || item.lay || 0) || 0;

            if (selection) {
              // Create keys for the selection as-is and with variations
              const keys = createExposureKeys(selection);
              keys.forEach(key => {
                if (key) {
                  // Use back/lay specific exposure if available, otherwise use general
                  if (backExposure !== 0) {
                    exposureMap[`${key} back`] = backExposure;
                  }
                  if (layExposure !== 0) {
                    exposureMap[`${key} lay`] = layExposure;
                  }
                  if (exposureAmount !== 0) {
                    exposureMap[key] = exposureAmount;
                  }
                }
              });

              // Also try with sid if available
              if (item.sid) {
                exposureMap[item.sid.toString()] = exposureAmount || backExposure || layExposure;
                exposureMap[`sid_${item.sid}`] = exposureAmount || backExposure || layExposure;
                if (backExposure !== 0) {
                  exposureMap[`${item.sid} back`] = backExposure;
                }
                if (layExposure !== 0) {
                  exposureMap[`${item.sid} lay`] = layExposure;
                }
              }
            }
          });

          // Debug: Log exposure map to see what keys we have
          if (Object.keys(exposureMap).length > 0) {
            console.log('Exposure Map:', exposureMap);
          }

          setExposures(prev => ({ ...prev, ...exposureMap }));
        }
      }
    } catch (error) {
      console.error('Error fetching exposure:', error);
    }
  }, [gameData?.data?.data?.mid]);

  useEffect(() => {
    const matchId = gameData?.data?.data?.mid?.toString();
    if (!matchId) return;

    const timeoutId = setTimeout(() => {
      fetchExposure();
    }, 5000);

    const intervalId = setInterval(() => {
      fetchExposure();
    }, 5000);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [gameData?.data?.data?.mid, fetchExposure]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.sectionA}>
          <CasinoHeading
            name="C MATCH 20"
            roundId={gameData?.data?.data?.mid || "157250124095658"}
            placedBetCount={myBets.length}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />

          {activeTab === "game" && (
            <>
              <VideoBox
                gameType="cmatch20"
                resultData={gameData?.data?.data?.card}
                iframeSrc={iframeSrc}
                timerValue={gameData?.data?.data?.lt}
              />

              <div className={styles.tableContainer}>
                <BetTableCmatch20
                  data={gameData?.data?.data?.sub || gameData?.data?.sub || []}
                  exposures={exposures}
                  gameData={gameData?.data?.data || gameData?.data || gameData || {}}
                />
              </div>

              <div className={styles.heading}>
                <div>Last Result</div>
                <Link to="/admin/reports/casinoresult/cmatch20">
                  <div className={styles.viewAll}>View All</div>
                </Link>
              </div>
              <ResultCt20
                data={gameData?.lrs || []}
                gameData={gameData}
                gameType="cmatch20"
              />
            </>
          )}

        </div>

        <RightSection
          sectionKey="cmatch20"
          data={myBets}
          title="Matched"
          viewMoreText="View More"
          onViewMore={() => {
            // Handle view more action
            console.log("View more clicked for cmatch20");
          }}
        />
      </div>
    </Layout>
  );
}

